import View from './view';
import {VisuallyImpairedGroup} from '../group';
import React from 'react';
import {ReduxWrapperProps} from './model';

export const VisuallyImpairedColor = View;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ReduxVisuallyImpairedColor = ({label, input: {onChange}, meta, ...props}: ReduxWrapperProps) => (
  <VisuallyImpairedGroup label={label}>
    <VisuallyImpairedColor {...props} onChange={onChange} />
  </VisuallyImpairedGroup>
);
